import { translations } from '../../translations';

export const enTranslation = {
    ...translations.en,
};
